import _, { values } from 'lodash';
import { makeUID } from '../../../../helpers';

const extractDataFromResponse = (resp) => (resp && !resp.error ? resp : []);
const extractUserRoles = (userRoles) => (userRoles && !userRoles.error ? ({
  curator: userRoles.curator,
  employer: userRoles.employer,
  head: userRoles.head,
  admin: userRoles.admin,
  participantAdmin: userRoles.participantAdmin,
  mainConstructor: userRoles.mainConstructor,
  officeTechLead: userRoles.officeTechLead,
}) : {});

export const getMngData = async (api) => {
  const letters = await api.get('/mng/letters');
  const finSources = await api.get('/mng/finsources');
  const kpis = await api.get('/mng/kpis');
  const userRoles = await api.get('/mng/proj/userRoles');
  const projTypes = await api.get('/mng/proj/types');
  const resultTypes = await api.get('/mng/proj/resulttypes');
  const policies = await api.get('/mng/strategies?isPortfolio=true');

  return {
    letters: extractDataFromResponse(letters),
    finSources: extractDataFromResponse(finSources),
    kpis: extractDataFromResponse(kpis).filter((kpi) => kpi.num && kpi.num[0] !== 'П'), // P2030-132 убрать все "П*" показатели
    userRoles: extractUserRoles(userRoles),
    projTypes: extractDataFromResponse(projTypes),
    resultTypes: extractDataFromResponse(resultTypes),
    policies: extractDataFromResponse(policies),
  };
};

export const prepareMngData = (mngData, portfolio) => ({
  ...mngData,
  kpis: mngData.kpis.filter((kpi) => portfolio.kpis.includes(kpi.id)),
});

export const getPeriodsData = async (api) => {
  const response = await api.get('/reports/periods/passport')
  return !response.error ? response : []
}

export const _default = {
  mngData: {
    letters: [],
    finSources: [],
    kpis: [],
    userRoles: [],
    projTypes: [],
    resultTypes: [],
  },
  project: (stratId, projId, portfolio, isNew) => {
    let users = [{
      id: 0, hash: makeUID(5), userId: undefined, displayName: '', user: {}, role: '', post: '',
    }];
    let pcs = [{
      id: 0, name: '', unit: '', isKey: false, values: [],
    }];

    if (isNew) {
      const foundHead = portfolio.head && portfolio.head.length && portfolio.head[0];
      if (foundHead) {
        users = [{
          ...foundHead, role: 'employer', id: 0, hash: makeUID(5),
        }];
      }

      pcs = portfolio.pcVals
        .filter((p) => (!p.startDate || new Date(p.startDate) <= new Date()) && (!p.endDate || new Date(p.endDate) >= new Date()))
        .map((pc, idx) => ({
          ...pc,
          id: 0 - idx,
          parentPcId: pc.id,
          parentPcOriginId: pc.pcOriginId,
          presetYears: pc.values.map((v) => v.year),
          values: [],
        }));
    }

    return {
      id: projId !== 'new' ? projId : 0,
      number: undefined,
      fullNumber: '',
      name: '',
      version: 1,
      approvedOn: '',
      categoryId: null,
      typeId: portfolio.typeId,

      strategyId: stratId || 0,
      strategyName: '',

      startDate: new Date().toISOString().substring(0, 10),
      endDate: new Date().toISOString().substring(0, 10),

      goal: '',
      descr: '',

      attachments: [],

      result: '',
      consumers: '',

      kpis: [],
      letters: [],
      results: [{
        id: 0, title: '', year: undefined, projResultTypeId: undefined, unit: '', value: '',
      }],
      pcs,
      plans: [{ id: 0, hash: makeUID(5), type: 'fb', year:'0' }],
      users,
      approvers: [],
    };
  },
};

// const getNewProjPcsDto = (pcs) => pcs.map((pc) => ({
//   ...pc,
//   id: 0,
//   parentPcId: pc.id,
//   parentPcOriginId: pc.pcOriginId,
// }));

const getProjPlansDto = (plans, portfolio) => plans.map((p) => {
  const foundPortfolioPlan = portfolio.plans.find((pp) => pp.id === p.portfolioPlanId);
  if (!foundPortfolioPlan) return undefined;

  return {
    ...foundPortfolioPlan,
    id: p.id,
    sum: p.sum,
  };
}).filter((p) => p);

export const getPortfolioProjDto = (proj, portfolio) => ({
  ...proj,
  // pcs: proj.id ? proj.pcs : getNewProjPcsDto(proj.pcs),
  plans: getProjPlansDto(proj.plans, portfolio),
  portfId: portfolio.id,
});

export const mapDtoPcs = (projPcs, portfolioPcs) => projPcs.map((projPc) => {
  const originPc = portfolioPcs.find((portfPc) => portfPc.id === projPc.parentPcId);

  return {
    ...projPc,
    presetYears: originPc ? originPc.values.map((v) => v.year) : [],
  };
});
